var admin = false;


function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

var modalWindow = '<div id="els-modal" class="modal-new"><div class="els-modal-content"><span class="close">&times;</span><div class="modal-product-info"></div></div></div>';
var mainContent = document.querySelector('#maincontent');
mainContent.insertAdjacentHTML('beforeend', modalWindow);

function addPreviewButton () {
var btnColor = hexToRgb('#666363');
var btnFill = 'rgba(' + btnColor.r + ', ' + btnColor.g + ', ' + btnColor.b +', ' + 0.9 + ')';
$('.quick-view-btn svg').attr('style', 'fill: ' + btnFill);
var btnHoverColor = hexToRgb('#e8e2e2');
var btnHoverFill = 'rgba(' + btnHoverColor.r + ', ' + btnHoverColor.g + ', ' + btnHoverColor.b +', ' + 0.9 + ')';
$('.quick-view-btn svg').attr('onmouseout', 'this.style.fill="' + btnFill + '"');
$('.quick-view-btn svg').attr('onmouseover', 'this.style.fill="' + btnHoverFill  + '"');
var product = [];
var modal = document.getElementById('els-modal');
var quickViewBtn = document.querySelectorAll('.quick-view-btn');
  for(var i=0; i < quickViewBtn.length; i++) {
  	  	quickViewBtn[i].onclick = function(event) {
          $('body').css({"overflow": "hidden"});
          $('#pageheader').addClass('lowHeaderIndex');
           $('#els-modal').addClass('els-showModal');
          	var url = '';
            var handle = event.currentTarget.getAttribute('handle');
			url = 'https://oldnewhouse.com/products/' + handle + '?view=quickView-json';
          	var productBlock = event.currentTarget.parentNode.parentNode;
          	var overloy = productBlock.querySelector('.imgcont .prod-img-overlay');
          	var overloyElement = '';
          if(overloy) {
          	overloyElement = '<img src="'+ overloy.getAttribute("src") +'" class="'+ overloy.getAttribute("class") +'" />';
          }
      $.ajax({
        type: "GET",
        url: url,
        crossDomain: true,
        success: function(res){
         var product = JSON.parse(res);
         var availableState = '';
         var sawPrice = '';
         var addToCartFlag = true;

         if(product.clean_price !== '999900') {
         	sawPrice = product.saw_price;
            if(product.available) {
                if(product.saw_compare_price !== product.saw_price_money) {
                  availableState = '<span class="reducedfrom">'+ product.saw_compare_price +'</span> '+ product.saw_price_money;
                } else {
                  availableState = product.saw_price_money;
                }
            } else {
              availableState = 'Sorry, this item is sold out.';
              addToCartFlag = false;
            }
         } else {
         	availableState = "Contact / email for Pricing";
           	addToCartFlag = false;
         }

        var carouselImages = '';
        product.images.forEach(function(image) {
        	carouselImages = carouselImages + '<li><a href="#"><img src="'+ image +'" title="'+ product.title +'" data-src="'+ image +'" data-large="'+ image +'" data-zoom="'+ image +'" alt="'+ product.title +'" data-description="" /></a></li>';
        });
        var carousel = '<div class="es-carousel"><ul>'+ carouselImages +'</ul></div>';
        var gallery = '<div id="productinfo" class="cf" data-featid="'+ product.id +'" data-featimgurl="'+ product.featured_image +'"><div id="gallery" class="gallery" itemscope itemtype="http://schema.org/ImageGallery"><div id="rg-gallery" class="rg-gallery"><div class="rg-image-wrapper"><div class="modal-image-box"><span class="modal-image-back">‹</span><div class="rg-image"></div><span class="modal-image-next">›</span></div><div class="rg-loading"></div><div class="rg-caption-wrapper"><div class="rg-caption" style="display:none;"><p></p></div></div><div class="rg-thumbs"><div class="es-carousel-wrapper">'+ carousel +'</div></div></div></div></div></div>';
          var addToCart = '';
          if(addToCartFlag) {
          	 addToCart = '<div class="addbuttoncont"><form action="/cart/add" method="post" id="product-form"><input type="hidden" name="id" value="'+ product.variants[0].id +'" /><input type="submit" name ="add" id="purchase" class="button large plus" value="BUY IT NOW!" /></form></div>';
          }
          var title = product.title;
          var size = '';
          if(product.product_type === 'Rugs') {
          	title = title.replace(/\s*\b\w*\d\w*\b/g, '').replace(/[.,]/g, '').replace(/RESERVED/g, "" ).trim();
           	size = '<span>Size: '+ product.variants[0].option1 +'</span>';
          }

          var icon = '';
            if(product.icon_availability === "1") {
              icon = '<img style="display: inline-block; width: 35px; height: 35px; padding-left: 15px; margin: -7px;" class="product-top-icon" src="//oldnewhouse.com/cdn/shop/t/105/assets/product_icon.png?v=98548708645245234131746126708" alt="Ships in 1 - 2 Business Days!"  title="Ships in 1 - 2 Business Days!" data-icon-product/>';
      		}
            var checkIfInWishlist = false;
            var addToWishlistClass = "add-wishlist";
            var updateWishlistClass = "update-wishlist";
            try{
                 checkIfInWishlist = quickViewWishlistChecker(product.variants[0].id);
                 if(!checkIfInWishlist) {
                    addToWishlistClass = "add-wishlist active";
                 }
                 else{
                    updateWishlistClass = "update-wishlist active";
                 }
            }
            catch(e){
                console.log(e);
            }
            
            var wishlistButton = `<div class="vt-wishlist-custom-plp vt-wishlist-quick-view-button vt-wishlist-container btn-class" 
            data-product="${product.id}" 
            data-variant="${product.variants[0].id}" 
            data-product-handle="${product.handle}" 
            data-product-image="${product.featured_image}" 
            data-product-title="${product.title}"> 
            <span class='${addToWishlistClass}'>
            <svg class="vt-product-icon vt-icon-heart" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path d="M340.8,98.4c50.7,0,91.9,41.3,91.9,92.3c0,26.2-10.9,49.8-28.3,66.6L256,407.1L105,254.6c-15.8-16.6-25.6-39.1-25.6-63.9  c0-51,41.1-92.3,91.9-92.3c38.2,0,70.9,23.4,84.8,56.8C269.8,121.9,302.6,98.4,340.8,98.4 M340.8,83C307,83,276,98.8,256,124.8  c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6L245.1,418l10.9,11l10.9-11l148.3-149.8  c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"/>
            </svg>
           <span>Add to Wishlist </span>
            </span>
            <span class='${updateWishlistClass}'>
            <svg class="vt-product-icon-filled vt-icon-heart" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path d="M340.8,83C307,83,276,98.8,256,124.8c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6  L245.1,418l10.9,11l10.9-11l148.3-149.8c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"/>
            </svg>
            <span>Update to Wishlist</span>
            </span>
             </div>`
          	var description = '<div class="modal-product-description">'+ product.description.substr(0, 160) +'...</br><a href="/products/'+product.handle+'">View full product details &#8594;</a></div>';
          	var sku = '<span>Item ID: '+ product.variants[0].sku +'</span>';
          	var modalInfo = document.querySelector('.els-modal-content .modal-product-info');
          	modalInfo.innerHTML = '<div class="modal-img-block">' + gallery + overloyElement + '</div><div class="modal-product-content"><h2>'+ title + icon +'</h2><span class="text_free_price">'+ availableState +'</span>'+ description + '<div class="modal-product-properties">'+ size + sku +'</div>'+  addToCart + wishlistButton + '</div>';
          	var parent = document.getElementById('container1');
			modalInfo.style.paddingRight = modalInfo.offsetWidth - modalInfo.clientWidth + "px";

            if('zoom' != 'hide') {
            $(function() {
                // gallery container
                var $rgGallery			= $('#rg-gallery'),
                // carousel container
                $esCarousel			= $rgGallery.find('div.es-carousel-wrapper'),
                // the carousel items
                $items				= $esCarousel.find('ul > li'),
                // total number of items
                itemsCount			= $items.length;
                if(itemsCount > 0) {
                    Gallery				= (function() {
                            // index of the current item
                    var current			= 0,
                        // mode : carousel || fullview
                        mode 			= 'carousel',
                        // control if one image is being loaded
                        anim			= false,
                        init			= function() {
                                // add large image wrapper
                                _addImageWrapper();
                                // show first image
                                _showImage( $items.eq( current ) );

                            // initialize the carousel
                            if( mode === 'carousel' )
                                _initCarousel();

                        },
                        _initCarousel	= function() {

                            // we are using the elastislide plugin:
                            // http://tympanus.net/codrops/2011/09/12/elastislide-responsive-carousel/
                            $esCarousel.css('display', 'flex').elastislide({
                                imageW 	: 80,
                                onClick	: function( $item ) {
                                    if( anim ) return false;
                                    anim	= true;
                                    // on click show image
                                    _showImage($item);
                                    // change current
                                    current	= $item.index();
                                }
                            });
                            // set elastislide's current to current
                            $esCarousel.elastislide( 'setCurrent', current );

                        },
                        _addViewModes	= function() {

                            // top right buttons: hide / show carousel

                            var $viewfull	= $('<a href="#" class="rg-view-full"></a>'),
                                $viewthumbs	= $('<a href="#" class="rg-view-thumbs rg-view-selected"></a>');

                            $rgGallery.prepend( $('<div class="rg-view"/>').append( $viewfull ).append( $viewthumbs ) );

                            $viewfull.on('click.rgGallery', function( event ) {
                                    if( mode === 'carousel' )
                                        $esCarousel.elastislide( 'destroy' );
                                    $esCarousel.hide();
                                $viewfull.addClass('rg-view-selected');
                                $viewthumbs.removeClass('rg-view-selected');
                                mode	= 'fullview';
                                return false;
                            });

                            $viewthumbs.on('click.rgGallery', function( event ) {
                                _initCarousel();
                                $viewthumbs.addClass('rg-view-selected');
                                $viewfull.removeClass('rg-view-selected');
                                mode	= 'carousel';
                                return false;
                            });

                            if( mode === 'fullview' )
                                $viewfull.trigger('click');

                        },
                        _addImageWrapper= function() {

                            // adds the structure for the large image and the navigation buttons (if total items > 1)
                            // also initializes the navigation events


                            if( itemsCount > 1 ) {
                                // addNavigation
                                    $imgWrapper		= $rgGallery.find('.modal-image-box .rg-image');
                                // add touchwipe events on the large image wrapper
                                $imgWrapper.touchwipe({
                                    wipeLeft			: function() {
                                        _navigate( 'right' );
                                    },
                                    wipeRight			: function() {
                                        _navigate( 'left' );
                                    },
                                    preventDefaultEvents: false
                                });

                                $(document).on('keyup.rgGallery', function( event ) {
                                    if (event.keyCode == 39)
                                        _navigate( 'right' );
                                    else if (event.keyCode == 37)
                                        _navigate( 'left' );
                                });

                                $('.modal-image-next').click(
                                  function () {
                                    _navigate( 'right' );
                                  }
                                );

                                $('.modal-image-back').click(
                                  function () {
                                    _navigate( 'left' );
                                  }
                                );

                            }

                        },
                        _navigate		= function( dir ) {

                            // navigate through the large images

                            if( anim ) return false;
                            anim	= true;

                            if( dir === 'right' ) {
                                if( current + 1 >= itemsCount )
                                    current = 0;
                                else
                                    ++current;
                            }
                            else if( dir === 'left' ) {
                                if( current - 1 < 0 )
                                    current = itemsCount - 1;
                                else
                                    --current;
                            }

                            _showImage( $items.eq( current ) );

                        },
                        _showImage		= function( $item ) {

                            // shows the large image that is associated to the $item

                            var $loader	= $rgGallery.find('div.rg-loading').show();

                            $items.removeClass('selected');
                            $item.addClass('selected');

                            var $thumb		= $item.find('img'),
                                largesrc	= $thumb.data('large'),
                                zoomsrc    = $thumb.data('zoom'),
                                title		= $thumb.data('description');
                            //Set new Pinit URL

                          $('#productinfo .social a[href][class^="PIN_"]').each(function(){

                                var thisHref = $(this).attr('href');
                                var qMarkPos = thisHref.indexOf('?');
                                var newHref = thisHref.substr(0, qMarkPos) + '?';
                                thisHref = thisHref.substr(qMarkPos + 1);
                                var splitQuery = thisHref.split('&');
                                for(var i=0; i<splitQuery.length; i++) {
                                    if(i>0) {
                                        newHref += '&';
                                    }
                                    var splitItem = splitQuery[i].split('=');
                                    if(splitItem[0] == 'media') {
                                        newHref += 'media=' + zoomsrc;
                                    } else {
                                        newHref += splitItem[0] + '=' + splitItem[1];
                                    }
                                }
                                $(this).attr('href', newHref);
                            });

                            $('<img/>').load( function() {
                                var $rgimgcont = $rgGallery.find('div.rg-image');
                                //For first-run
                                if($rgimgcont.find('a').length == 0) {
                                    $rgimgcont.append($('<a>').hide());
                                }

                                 if(('zoom' == 'lightbox' || 'zoom' == 'hide')/* && !('ontouchstart' in window) ? 1 : 0*/) {
                                    //Add lightbox only
                                    $rgimgcont.find('a').fadeOut(400, function(){
                                        $(this).remove();
                                        $rgimgcont.append('<a href="' + zoomsrc + '" target="_blank"><img src="' + largesrc + '"/></a>');
                                        if( title ){
                                            $rgGallery.find('div.rg-caption').show().children('p').empty().text( title );
                                        }
                                        //Init lightbox in gallery mode
                                  if($(window).width()>480) {
                                        $rgimgcont.find('a').click(function(){
                                            //Build gallery image list
                                            var gallImgs = Array();
                                            var thisItemIndex = 0;
                                            var $allGallImgs = $('#rg-gallery .es-carousel img');

                                            for(var i=0; i<$allGallImgs.length; i++) {
                                                var thisZoomSrc = $($allGallImgs[i]).data('zoom');
                                                gallImgs.push([thisZoomSrc]);
                                                if(zoomsrc == thisZoomSrc) { thisItemIndex = i; }
                                            }
                                            $.slimbox(gallImgs, thisItemIndex, {loop: true});
                                            return false;
                                        });
                                  }
                                        $loader.hide();
                                        $rgimgcont.find('img').animate({opacity:1}, 400, function(){
                                            $(this).closest('.loadingimg').removeClass('loadingimg')
                                        });
                                    });
                                } else {
                                    //Add just the image

                                    $rgimgcont.find('a').fadeOut(400, function(){
                                        $(this).remove();
                                        $rgimgcont.append('<a><img src="' + largesrc + '"/></a>');


                                        if( title ){
                                            $rgGallery.find('div.rg-caption').show().children('p').empty().text( title );
                                        }
                                        $loader.hide();
                                        $rgimgcont.find('img').animate({opacity:1}, 400, function(){
                                            $(this).closest('.loadingimg').removeClass('loadingimg')
                                        });
                                    });
                                }
                                if( mode === 'carousel' ) {
                                    $esCarousel.elastislide( 'reload' );
                                    $esCarousel.elastislide( 'setCurrent', current );
                                }
                                anim = false;
                              $item.trigger('mainimgloaded');//Added for variant-images
                            }).attr( 'src', largesrc );

                        },
                        addItems		= function( $new ) {
                            $esCarousel.find('ul').append($new);
                            $items 		= $items.add( $($new) );
                            itemsCount	= $items.length;
                            $esCarousel.elastislide( 'add', $new );

                        };

                    return {
                        init 		: init,
                        addItems	: addItems
                    };

                })();
                    Gallery.init();
                }
            });
        }

        }
      });
    };
}
var span = document.querySelector(".els-modal-content .close");

span.onclick = function() {
$('#els-modal').removeClass('els-showModal');
  $('#pageheader').removeClass('lowHeaderIndex');
  $('body').css({"overflow": "auto"});
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
		$('#els-modal').removeClass('els-showModal');
       $('#pageheader').removeClass('lowHeaderIndex');
      $('body').css({"overflow": "auto"});
    }
}
};

if(window.location.href.indexOf('size-and-image-search') === -1 && window.location.href.indexOf('sizes-filter') === -1 && window.location.href.indexOf('/products/') === -1) {
    window.addPreviewButton();
}



function initProductIcons() {
  var productIcons = document.querySelectorAll('[data-icon-product]');
  for(var i = 0; i < productIcons.length; i++){
    var icon = productIcons[i];
    icon.addEventListener('click', function(event){
      if(document.body.clientWidth < 769){
        var modal = document.getElementById('els-modal');
        if(modal){
          modal.classList.add('els-showModal');
          var modalInfo = modal.querySelector('.els-modal-content .modal-product-info'),
              pageHeader = document.getElementById('pageheader'),
              body = document.querySelector('body');
          if(modalInfo){
            modalInfo.style.padding = 0;
            modalInfo.style.textAlign = 'center';
            modalInfo.innerHTML = '<p style="width: 100%; margin: 10px 0;">' + event.target.alt + '</p>';
          }
          if(pageHeader){
            pageHeader.classList.add('lowHeaderIndex');
          }
          body.style.overflow = 'hidden';
        }
      }
    });
  }
}

initProductIcons();
